<template>
  <v-row>
    <v-col cols="auto">
      <v-icon class="mt-6"> mdi-translate </v-icon>
    </v-col>
    <v-col cols="5">
      <v-select v-model="selectedLanguage" dense :items="langs" />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from "../composables/useI18n";

const { locale } = useI18n();

const selectedLanguage = ref(locale.value);
const langs = ["de", "en"];

watch(selectedLanguage, (value) => {
  locale.value = value;
});

defineOptions({
  name: "locale-changer"
});
</script>
